import { render, staticRenderFns } from "./ShiftLogs.vue?vue&type=template&id=ba1d699a&scoped=true"
import script from "./ShiftLogs.vue?vue&type=script&lang=js"
export * from "./ShiftLogs.vue?vue&type=script&lang=js"
import style0 from "./ShiftLogs.vue?vue&type=style&index=0&id=ba1d699a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba1d699a",
  null
  
)

export default component.exports